/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access */
// node modules
import registerPromiseWorker from 'promise-worker/register';
// modules
import Parser from './parser.worker';
// consts
import { BOD_URL, BOD_VERSION } from './constants';

class BodService extends Parser {
  private fetchBod = async () => {
    const response = await fetch(`${BOD_URL}/bod_v_${BOD_VERSION}.json`);

    const data = (await response.json()) as ScripFile;

    return data;
  };

  init = () =>
    new Promise(res => {
      (async () => {
        const bodFile: ScripFile = await this.fetchBod();

        this.parseData(bodFile);

        res(true);
      })();
    });
}

const _bodService = new BodService();

registerPromiseWorker((message: BodSearchWorkerMessages): unknown => {
  switch (message.event) {
    case 'SEARCH_BY_TOKEN': {
      const exchangeToken = message.data;

      return _bodService.searchBasedOnPropertyAsync(exchangeToken, 'token');
    }

    case 'SEARCH_BY_INSTRUMENT_KEY': {
      const instrumentKey = message.data;

      return _bodService.searchBasedOnPropertyAsync(
        instrumentKey,
        'instrumentKey',
      );
    }

    case 'BOD_PARSE': {
      return _bodService.init();
    }

    case 'GET_OPTION_EXPIRY': {
      const { exchangeToken, spotToken } = message.data;

      return _bodService.getOptionExpiries(exchangeToken, spotToken);
    }

    case 'GET_OPTION_STRIKES_FOR_EXPIRY': {
      const { expiry, exchangeToken } = message.data;

      return _bodService.getOptionStrikesForExpiry(exchangeToken, expiry);
    }

    case 'GET_FUTURE_SCRIP_FOR_EXPIRY': {
      const { exchangeToken } = message.data;

      return _bodService.getFutureScripForExpiry(exchangeToken);
    }

    case 'INSERT_DATA_IN_DB': {
      return _bodService.insertDataInDb();
    }

    default:
      return undefined;
  }
});
